module.exports = __webpack_public_path__ + "img/cloth_g3_shirt-11.887ad5e7.svg";